export const UPURL =  'https://backapi.ucreagent.com';  //图片前缀https://jtestsadminapi.aiiso.com  https://backapi.UC reagent.com